import { all } from 'redux-saga/effects';

import jalesTransitoSaga from './jalesTransito/combineSaga';

export default all([jalesTransitoSaga]);
